module.exports = __webpack_public_path__ + "static/media/icon_nav_on_partner.4cf6f4eb.svg";